import { gql, useMutation } from "@apollo/client";
import { DialogContent } from "@material-ui/core";
import { Form, Formik } from "formik";
import React from "react";
import { useAppDialog } from "../../../app-dialog";
import { AttendeeFragment, AttendeeModel } from "../../../models/attendee.model";
import { BasicDialogActions } from "../../../ui/dialog";
import { LoadingButton } from "../../../ui/loading-button";
import { AttendeeForm } from "./attendee.form";
import { AttendeeInitialValues, AttendeeValidationSchema } from "./attendee.validation";

const MUTATION = gql`
    mutation insert($object: attendee_insert_input!) {
        insert_attendee_one(object: $object) {
            ${AttendeeFragment}
        }
    }
`;

type Props = {
    event_id: number;
    onFinish: (attendee: AttendeeModel, is_new?: boolean) => void;
}

export const AttendeeCreate = ({
    event_id,
    onFinish,
}: Props) => {
    const [insert, status] = useMutation(MUTATION)
    const app_dialog = useAppDialog();

    const onSubmit = async (values: any) => {
        try {
            const { data } = await insert({
                variables: {
                    object: {
                        ...values,
                    }
                }
            });
            const attendee = data?.insert_attendee_one;
            if (!attendee) {
                return;
            }
            onFinish(attendee, true);
        } catch (e: any) {
            app_dialog.showError(e);
        }
    }
    return <Formik initialValues={AttendeeInitialValues()}
        validationSchema={AttendeeValidationSchema}
        onSubmit={onSubmit}>{() => <Form noValidate>
            <DialogContent>
                <AttendeeForm event_id={event_id} />
            </DialogContent>
            <BasicDialogActions>
                <LoadingButton loading={status.loading}
                    color='primary'
                    type='submit'
                    size='large'
                    variant='contained'>
                    Create
                </LoadingButton>
            </BasicDialogActions>
        </Form>}
    </Formik>
}
